import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import MainLayout from '../../theme/layouts/MainLayout';
import HomePage from '../../pages/home/'
import AudiencePage from '../../pages/audience'
import SolutionPage from '../../pages/solutions'
import LetsTalk from '../../pages/letsTalk';
import OaPolicy from '../../pages/oa-policy';
// import CaptchForm from '../components/forms/CaptchaForm';
import CES from '../../pages/ces';
import ThankYou from '../../pages/thank-you';
import PageNotFound from '../../pages/404Page';
import InsightScreen from '../../pages/insight';
import Article from '../../pages/insight/Article';
import BrandedBBAds from '../../pages/new-pages/brandedBBAds';
import BrandedCompetitors from '../../pages/new-pages/brandedCompetitors';
import NonBrandedAudiences from '../../pages/new-pages/nonBrandedAudiences';
import NonBrandedSolutions from '../../pages/new-pages/nonBrandedSolutions';

// import ReactGTM from 'react-gtm-module';

// // GTM configuration
// const gtmId = "GTM-5ZKNGP2"; // Replace with your GTM ID

// // Initialize GTM
// ReactGTM.initialize({ gtmId });

// const PageView = () => {
//   const location = useLocation();

//   useEffect(() => {
//     // Track page view event
//     ReactGTM.dataLayer({ page: location.pathname });
//   }, [location]);

//   return null;
// };


const AppRoute = () => {

  const navigate = useNavigate();

  useEffect(() => {
    // Detect trailing slash in URL
    const path = window.location.pathname;
    
    if (path !== '/' && path.endsWith('/')) {
      // Remove the trailing slash
      const newPath = path.slice(0, -1);
      // Replace the URL without reloading the page
      window.history.replaceState(null, '', newPath);
      // Navigate to the updated URL (without trailing slash)
      navigate(newPath, { replace: true });
    }
  }, [navigate]);

  return (
    <>
      {/* <PageView /> */}
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/audience" element={<AudiencePage />} />
          <Route path="/solutions" element={<SolutionPage />} />
          {/* <Route path='/:moduleTab' element={<InsightScreen />} /> */}
          <Route path="/success-story" element={<InsightScreen />} />
          <Route path="/intel-ideas" element={<InsightScreen />} />
          <Route path="/whats-news" element={<InsightScreen />} />
          <Route path='/:moduleTab/:slug' element={<Article />} />
          <Route path="/lets-talk" element={<LetsTalk />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/oa-policy" element={<OaPolicy />} />
          <Route path="/innovations-and-partnerships" element={<CES />} />
          <Route path="/lp/rmn" element={<BrandedBBAds />} />
          <Route path="/lp/retail-media-for-tech" element={<BrandedCompetitors />} />
          <Route path="/lp/tech-audiences" element={<NonBrandedAudiences />} />
          <Route path="/lp/retail-media-solutions" element={<NonBrandedSolutions />} />
          {/* <Route path="/rnd" element={<CaptchForm />} /> */}
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoute
